export const TRANSLATIONS_ES = {
  approveAdmin:
    'Haga clic en el botón aprobar / rechazar para aprobar o rechazar al administrador',
  pendingAdminApprovals: 'Aprobaciones de administrador pendientes',
  ApprovedAdmins: 'Administradores Aprobados',
  Listofapprovedadmins:
    'La siguiente lista menciona la lista de administradores aprobados en el sistema. Haga clic en Eliminar para despojarlos del estado de administrador.',
  Coursesthatrequireyourapproval: 'Cursos que requieren tu aprobación',
  approveordeclinethecourse:
    'Haga clic en el botón aprobar / rechazar para aprobar o rechazar el curso.',
  AllCourses: 'Todos los cursos',
  listofallthecurrentcourses:
    'La siguiente lista muestra una lista de todos los cursos actuales.',
  NoPendingAdmins: 'Sin Administradores Pendientes.',
  Nocourses: 'No hay cursos',
  NoPendingcourseapprovalrequests:
    'No hay solicitudes de aprobación de cursos pendientes.',
  PENDINGADMINS: 'ADMINISTRADORES PENDIENTES',
  APPROVEDADMINS: 'ADMINISTROS APROBADOS',
  PENDINGCOURSES: 'CURSOS PENDIENTES',
  APPROVEDCOURSES: 'CURSOS APROBADOS',
  SUGGESTADMIN: 'ADMINISTRADOR SUGERIDO',
  Name: 'Nombre',
  Email: 'Correo electrónico',
  Nameofrequester: 'Nombre del solicitante',
  Reasonforrequest: 'Razón de la solicitud',
  Actions: 'Comportamiento',
  Username: 'Nombre de usuario',
  Approve: 'Aprobar',
  Decline: 'Disminución',
  Remove: 'Eliminar',
  CourseName: 'Nombre del Curso',
  CourseDescription: 'Descripción del curso',
  Description: 'Descripción',
  Logout: 'Cerrar sesión',
  CourseType: 'Tipo de curso',
  Statusofrequest: 'Estado de la solicitud',
  SuggestedAdminStatus: 'Estado de administrador sugerido',
  specifyreasonadminsuggestion:
    'Especifique un motivo para la sugerencia del administrador:',
  EnterReason: 'Ingrese la razón',
  Thiscategoryhasnocourses: 'Esta categoría no tiene cursos',
  AddNewCourse: 'Agregar nuevo curso',
  Thiscoursehasnosections: 'Este curso no tiene secciones.',
  Thissectionhasnolectures: 'Esta sección no tiene conferencias.',
  AddNewLecture: 'Agregar nueva conferencia',
  HOME: 'CASA',
  MYCOURSES: 'MIS CURSOS',
  STATISTICS: 'ESTADÍSTICAS',
  Pleasechooseacategorytoaddacourse:
    'Elija una categoría para agregar un curso.',
  Pleasechooseasectiontoaddalecture:
    'Elija una sección para agregar una conferencia.',
  AddSection: 'Agregar sección',
  ADD: 'AGREGAR',
  Checkthestatusofyourcourses: 'Consulta el estado de tus cursos',
  AdminComment: 'Comentario del administrador',
  Status: 'Estado',
  TotalLectures: 'Total de conferencias',
  TotalCourses: 'Cursos totales',
  TotalSections: 'Secciones totales',
  TotalCategories: 'Categorías totales',
  EnrolledCourses: 'Cursos inscritos',
  ENROLLEDCOURSES: 'CURSOS INSCRITOS',
  ALLCOURSES: 'TODOS LOS CURSOS',
  CONTACTSUPPORT: 'SOPORTE DE CONTACTO',
  FreeCourse: 'Curso gratuito',
  PaidCourse: 'Curso pagado',
  ENROLL: 'INSCRIBIRSE',
  Clicktoviewlectures: 'Haga clic para ver conferencias',
  WatchLecture: 'Ver conferencia',
  Youarecurrentlynotenrolledinanycourse:
    'Actualmente no estás inscrito en ningún curso',
  GoBack: 'Regresa',
  GoBacktoLectureList: 'Volver a la lista de conferencias',
  EnterSupportMessage: 'Ingrese el mensaje de soporte',
  SEND: 'ENVIAR',
  Thisisafreecourse: 'Este es un curso gratuito',
  Thisisapaidcourse: 'Este es un curso pagado',
  ThiscoursehasnocontentPleasecheckbacklater:
    'Este curso no tiene contenido. Por favor, vuelva más tarde',
  AddNote: 'Añadir la nota',
  LectureNotes: 'Notas de lectura',
  NoteDescription: 'Nota Descripción',
  ALLUSERS: 'TODOS LOS USUARIOS',
  SUGGESTCATEGORY: 'CATEGORÍA SUGERIDA',
  CategoryName: 'nombre de la categoría',
  CategoryDescription: 'Descripción de categoría',
  EnterCategoryDescription: 'Ingrese la descripción de la categoría'
};
